import { Icon } from '@chakra-ui/react';

export const CustomMinusIcon = (props) => (
  <Icon vwidth="27" height="6" viewBox="0 0 27 6" fill="none" {...props}>
    <rect x="0.457031" y="0.210938" width="26" height="5.2" rx="2" fill="currentColor" />
  </Icon>
);
